const Axios = require("axios");

export function getAcknowledgement(accessionId = "") {
  // if (process.env.NODE_ENV === "production") {
  if (accessionId === null)
    return new Promise((res) => {
      res({});
    });
  const accessionIdNumber = accessionId.split("_")[2];
  if (accessionIdNumber === undefined) {
    return new Promise((res) => {
      res({});
    });
  }
  const url =
    "https://www.epicov.org/acknowledgement/" +
    accessionIdNumber.charAt(accessionIdNumber.length - 4) +
    accessionIdNumber.charAt(accessionIdNumber.length - 3) +
    "/" +
    accessionIdNumber.charAt(accessionIdNumber.length - 2) +
    accessionIdNumber.charAt(accessionIdNumber.length - 1) +
    "/" +
    accessionId +
    ".json";
  return Axios.get(url)
    .then((result) => {
      return result.data;
    })
    .catch((err) => {
      console.log("err :>> ", err);
      return {};
    });
  // } else {
  //   return new Promise((res, rej) => {
  //     setTimeout(() => {
  //       const ack = require("../assets/data/acknowledgement.json");
  //       res(ack);
  //     }, 1000);
  //   });
  // }
}
